<mat-chip [class.active]="value !== null" (click)="isOpen = true" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <div class="chip-content">
    <mat-icon [fontIcon]="icon"></mat-icon>
    <span class="clickable text">
      {{ value ? displayWith(findWith(options, value)) : (labelKey | translate) }}
    </span>
    <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
    @if (value !== null) {
      <button matChipRemove (click)="sendClear()">
        <mat-icon>cancel</mat-icon>
      </button>
    }
  </div>
</mat-chip>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
  <div class="overlay-container">
    <app-singular-autocomplete
      [idKey]="idKey"
      [inputName]="name + '-filter'"
      [options]="options"
      [filter]="filterWith"
      [displayAutoCompleteValue]="displayWith"
      (selectOption)="optionSelected.emit($any($event)[idKey]); isOpen = false"
    ></app-singular-autocomplete>
  </div>
</ng-template>
